import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useLayoutEffect, useRef, useState } from "react";
import getScrollParent from "scrollparent";
import IntlMessageFormat from "intl-messageformat";
import { useStringMap } from "../utilities/string-map/useStringMap";
import { HelpPopover } from "../help-popover/HelpPopover";
import { MenuListContext } from "../menu-list/MenuListContext";
import { InfoIcon, InfoIconButton } from "./MenuListItem.styled";
import { getMenuListItemControlRole } from "./getMenuListItemControlRole";
import { stringMapDefault } from "./MenuListItem.stringMap";
export const MenuListItemDetails = (props) => {
    const { mode } = useContext(MenuListContext);
    const { label, details, stringMap: stringMapProp } = props;
    const { detailsLabel } = useStringMap("MenuListItem", {
        stringMapDefault,
        stringMapProp
    });
    const role = getMenuListItemControlRole({ mode });
    const iconRef = useRef();
    const [isOpened, setIsOpened] = useState(false);
    // TODO: extract into global Popper API or use controlled isOpen state for HelpPopover
    useLayoutEffect(() => {
        if (iconRef.current && isOpened) {
            // scrollparent type is incorrect, null cannot be returned for a valid element, and iconRef.current is not null
            const scrollParent = getScrollParent(iconRef.current);
            const scrollHandler = () => {
                // Popper subscribes to click events using using ClickAwayHandler, emit a fake event to execute click outside logic
                const fakeEvent = new MouseEvent("click", {
                    view: window,
                    bubbles: true,
                    cancelable: true
                });
                scrollParent.dispatchEvent(fakeEvent);
                // on outside click focus is not restored, do it manually
                iconRef.current?.focus();
            };
            scrollParent.addEventListener("scroll", scrollHandler, { once: true, passive: true });
            return () => scrollParent.removeEventListener("scroll", scrollHandler);
        }
        return () => { };
    }, [isOpened]);
    return (_jsx(HelpPopover, { size: "medium", placement: "right", popoverWidth: "90vw", "aria-label": typeof detailsLabel === "function"
            ? detailsLabel(label ?? "")
            : new IntlMessageFormat(detailsLabel).format({
                // TODO: make labelString type required on MenuListItem or render React label via ScreenReaderContent instead
                label: label ?? ""
            }), renderTrigger: ({ size, ...triggerProps }) => (_jsx(InfoIconButton, { ref: iconRef, ...triggerProps, role: role, "data-testid": "MenuListItemDetails", children: _jsx(InfoIcon, { size: size, "aria-hidden": "true", palette: "structural" }) })), onOpen: () => setIsOpened(true), onClose: () => setIsOpened(false), children: details }));
};
